import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { faThLarge, faCalculator, faList,  faBars } from '@fortawesome/free-solid-svg-icons';
import { faUser, faBuilding, faPlusSquare, faEdit, faAddressBook } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {

  // Separate state variables for desktop and mobile
  public isDesktopCollapsed = false;
  public isMobileOpen = false;
  public isMobile = false;

  // FontAwesome icons
  public faUser = faUser;
  public faThLarge = faThLarge;
  public faBars = faBars;
  public faBuilding = faBuilding;
  public faPlusSquare = faPlusSquare;
  public faEdit = faEdit;
  public faCalculator = faCalculator;
  public faList = faList;
  public faAddressBook = faAddressBook;
  get isCollapsed(): boolean {
    return this.isMobile ? false : this.isDesktopCollapsed;
  }

  get isSidebarOpen(): boolean {
    return this.isMobile ? this.isMobileOpen : true;
  }

  get shouldShowLogo(): boolean {
    return this.isMobile ? this.isMobileOpen : !this.isDesktopCollapsed;
  }

  get shouldShowNavText(): boolean {
    return this.isMobile ? this.isMobileOpen : !this.isDesktopCollapsed;
  }

  private mobileToggleListener: (event: Event) => void;

  constructor() {
    this.mobileToggleListener = (event: CustomEvent) => {
      if (this.isMobile) {
        this.isMobileOpen = event.detail.open;
        localStorage.setItem('mobileSidebarOpen', JSON.stringify(this.isMobileOpen));
      }
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
    this.loadSavedState();
    
    // Listen for mobile toggle events from header
    window.addEventListener('mobileToggleSidebar', this.mobileToggleListener);
  }

  ngOnDestroy() {
    window.removeEventListener('mobileToggleSidebar', this.mobileToggleListener);
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 768;
    
    if (!this.isMobile && this.isMobileOpen) {
      this.isMobileOpen = false;
      localStorage.setItem('mobileSidebarOpen', JSON.stringify(this.isMobileOpen));
    }
  }

  private loadSavedState(): void {
    const desktopState = localStorage.getItem('desktopSidebarCollapsed');
    if (desktopState !== null) {
      this.isDesktopCollapsed = JSON.parse(desktopState);
    }

    const mobileState = localStorage.getItem('mobileSidebarOpen');
    if (mobileState !== null) {
      this.isMobileOpen = JSON.parse(mobileState);
    }
  }

  /**
   * Toggle sidebar collapsed state (desktop behavior)
   */
  toggleSidebar(): void {
    if (this.isMobile) {
      this.closeMobileSidebar();
    } else {
      this.isDesktopCollapsed = !this.isDesktopCollapsed;
      localStorage.setItem('desktopSidebarCollapsed', JSON.stringify(this.isDesktopCollapsed));
    }
  }

  /**
   * Close mobile sidebar and update storage
   */
  private closeMobileSidebar(): void {
    this.isMobileOpen = false;
    localStorage.setItem('mobileSidebarOpen', JSON.stringify(this.isMobileOpen));
  }

  /**
   * Handle navigation link click on mobile - auto-close sidebar
   */
  onMobileNavigate(): void {
    if (this.isMobile && this.isMobileOpen) {
      setTimeout(() => {
        this.closeMobileSidebar();
      }, 150);
    }
  }

}
